const spacingFluidMedium = 'clamp(16px, 1.25vw + 12px, 36px)';

export { spacingFluidMedium };
